import TrackerActions from '@Actions/trackerActions';
import { put } from 'redux-saga/effects';
import { createModule } from '../actions/utils';
import { SERVICE_ENDPOINT } from '../apis/constants';

const AddByProductMO = createModule({
  base: 'ADD_BP_MO',
  apiDetails: SERVICE_ENDPOINT.ADD_BP_MO,
  // customHandler: {
  //   * afterSuccess(mo) {
  //     yield put(TrackerActions.trackAction('ADD_BP_MO_SUCCESS', mo.data));
  //   },
  //   * onError(error) {
  //     yield put(TrackerActions.trackAction('ADD_BP_MO_FAILURE', error));
  //   },
  // },
});

const RemoveByProductMO = createModule({
  base: 'REMOVE_BP_MO',
  apiDetails: SERVICE_ENDPOINT.REMOVE_BP_MO,
  // customHandler: {
  //   * afterSuccess(mo) {
  //     yield put(TrackerActions.trackAction('REMOVE_BP_MO_SUCCESS', mo.data));
  //   },
  //   * onError(error) {
  //     yield put(TrackerActions.trackAction('REMOVE_BP_MO_FAILURE', error));
  //   },
  // },
});

export { AddByProductMO, RemoveByProductMO };
